import { Fragment } from 'react';
import { Helmet } from 'react-helmet-async';
import { useHistory, useParams } from 'react-router-dom';
import PortfolioScripts from 'app/design/speedBot/ComponentItem/Portfolio/PortfolioScripts';
import PageHeader from 'app/design/speedBot/PageHeader';
import StatusMessage from 'app/components/Common/StatusMessage';
import FormattedMessage from 'app/design/uiComponents/FormattedMessage';
import Breadcrumbs from 'app/design/uiComponents/Breadcrumbs';
import { PAGES } from 'app/components/Common/Breadcrumb/types';
import CircularLoader from 'app/design/uiComponents/CircularLoader';

// Services
import useGetBotHistoryDetail from 'services/Bots/useGetBotHistoryDetail';

export function BotHistorySymbolsPage() {
  const { bid, sid, title, hsid, subtitle } = useParams<{
    bid: string;
    sid: string;
    title: string;
    hsid: string;
    subtitle: string;
  }>();
  const history = useHistory();
  const subId = isNaN(parseInt(sid)) ? 0 : parseInt(sid);
  const botId = parseInt(bid);
  const { data, isLoading } = useGetBotHistoryDetail(bid, hsid);
  const scripts = data?.scripts || [];

  return (
    <Fragment>
      <Helmet>
        <title>Bot History Symbols</title>
        <meta name="description" content="Bot History Symbols Page" />
      </Helmet>
      <CircularLoader open={isLoading} />
      <PageHeader
        variant="inactive"
        title={<FormattedMessage id="bots.page_title.symbols" />}
        buttonText={subtitle}
        buttonHandleClick={() => {
          history.goBack();
        }}
        breadcrumb={
          <Breadcrumbs
            page={PAGES.BOT_HISTORY_SYMBOLS}
            data={{
              subId,
              botId,
              botName: title,
              historySubId: hsid,
              title: subtitle,
            }}
          />
        }
      />
      {scripts.length > 0 ? (
        <PortfolioScripts scripts={scripts} />
      ) : (
        <StatusMessage
          title={<FormattedMessage id="bots.symbols.status_msg.title" />}
          subtitle={<FormattedMessage id="bots.symbols.status_msg.sub_title" />}
        />
      )}
    </Fragment>
  );
}
